module.exports = __webpack_public_path__ + "static/power3-2-4dcac195192b1c70d1ad93c006a50860.png";